export const environment = {
  production: false
};




export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyCbKA3oCYUcKv4XQb8g8t0dzxFEAzoLn04",
  authDomain: "fusioneta-test.firebaseapp.com",
  databaseURL: "https://fusioneta-test-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "fusioneta-test",
  storageBucket: "fusioneta-test.appspot.com",
  messagingSenderId: "167207020456",
  appId: "1:167207020456:web:d199f2e965a4a037e39f9d"
};




export const baseUrl2 = 'https://us-central1-fusioneta-test.cloudfunctions.net/altomateTax'
export const einvoiceUrl = 'https://us-central1-fusioneta-test.cloudfunctions.net/einvoice'
// export const accountingUrl = 'https://asia-southeast1-fusioneta-test.cloudfunctions.net/altomateAccounting'
// export const accountingUrl ='http://localhost:5001/fusioneta-test/asia-southeast1/altomateAccounting'
// export const accountingUrl = 'https://asia-southeast1-cwceng-entitymanagement.cloudfunctions.net/altomateAccounting'
// export const payrollUrl = 'http://localhost:5001/cwceng-entitymanagement/asia-southeast1/altomatePayroll'
// export const payrollUrl = 'http://localhost:5001/fusioneta-test/asia-southeast1/altomatePayroll'
export const payrollUrl = 'https://asia-southeast1-cwceng-entitymanagement.cloudfunctions.net/altomatoePayroll'

// export const payrollUrl = 'https://us-central1-fusioneta-test.cloudfunctions.net/altomatePayroll'
// External payroll app (Workpulse) base URL — main payroll system lives outside Altomate.
// TODO: provided by Altomate — set to the actual external payroll app URL.
export const payrollAppUrl = 'https://hr.altomate.io'
// export const aiBookkeepingWorkspaceUrl = 'https://asia-southeast1-fusioneta-test.cloudfunctions.net/document_parser'
export const aiBookkeepingWorkspaceUrl = 'https://asia-southeast1-cwceng-entitymanagement.cloudfunctions.net/document_parser'
// AI document extraction for payroll movement (offer letter / TP3).
export const aiInvoiceParserUrl = 'https://asia-southeast1-fusioneta-test.cloudfunctions.net/AI-Invoice-Parser'
// MyInvois portal host for validated-document share links
// (https://<host>/<uuid>/share/<longId>). Flip to myinvois.hasil.gov.my for production.
export const myInvoisPortalUrl = 'https://preprod.myinvois.hasil.gov.my'
// export const accountingUrl = 'https://prod.accounting.altomate.io'
// export const baseUrl = 'https://prod.altomate.io'
// export const accountingUrl = 'https://us-central1-fusioneta-test.cloudfunctions.net/altomateAccounting'
export const domainUrl = 'https://prod-domain-api.altomate.io'
// TEMPORARY - remove together with F-01.
// Documents are currently filed under a hardcoded supplier TIN in the accounting
// backend (mapInvoiceToParams), NOT under the organisation's own TIN. LHDN only
// returns a document to a TIN that is a party to it, so the PDF's validated-link
// lookup has to ask using the same TIN the submission used. Once the backend files
// under a_organisation.tin, delete this and let the org TIN behttp://localhost:5001/fusioneta-test/asia-southeast1/widgets4 used instead.
export const myInvoisFilingTin = 'C26542225060'
export const accountingUrl = 'https://us-central1-fusioneta-test.cloudfunctions.net/altomateAccounting'
export const baseUrl = 'https://staging.altomate.io'
// ocbc-bank Express server (OCBC account-opening API). Leave empty to keep the redirect to OCBC's own form.
export const ocbcBankUrl = 'https://staging.ocbc.altomate.io'
export const socketUrl = 'https://socket.softon.io'
export const frontend_url = 'https://test.altomate.io/'
// export const payrollUrl = 'https://asia-southeast1-cwceng-entitymanagement.cloudfunctions.net/altomatePayroll'
export const deeplinkUrl = 'https://redirect.altomate.io'
// export const aiInvoiceParserUrl = 'https://asia-southeast1-fusioneta-test.cloudfunctions.net/AI-Invoice-Parser'
// export const domainUrl = 'https://prod-domain-api.altomate.io'
// export const payrollAppUrl = 'https://hr.altomate.io'
// export const aiBookkeepingWorkspaceUrl = 'https://asia-southeast1-fusioneta-test.cloudfunctions.net/document_parser'


export const stripePublishableKeyMalaysia = 'pk_live_51IlDnFBSHlgFmY5xbB31gfm1MVB5BeXqix4rgDGFIcGbmhmdkx8NnlHjbK0RN387dLLXSpLH1XbPurl91eLZcR5l00EIYz5KBn'
export const stripePublishableKeySingapore = 'pk_live_51STGmEDH8fTxrB3Naey6rU3OH582xFcddecSknGJZ0jtviw25KDap0HcZ9WxbO5gDMxpaDJpdmIx85NsZPzhOpnw00bhKckh0N'
export const websiteVersion = '5.6.0'
export const iosVersion = '5.0.0'
export const androidVersion = '5.0.0'

// Altomate AI agents (mastra) backend — used by the ai-chat page
// export const agentApiBaseUrl = 'http://localhost:4112/'
export const agentApiBaseUrl = 'https://staging.agent.altomate.io'

export const agentChannel = 'web'
export const agentDefaultCountry = 'malaysia'